import React from 'react';
import { ComposableMap, Geographies, Geography } from 'react-simple-maps';
import TravelMapShell from './TravelMapShell.jsx';
import { geographyStyles } from './mapGeographyStyles';

// Higher resolution map data
const GEO_URL = "https://cdn.jsdelivr.net/npm/world-atlas@2/countries-50m.json";

// Asian countries with ISO 3166-1 numeric codes
const ASIAN_COUNTRIES = [
    { code: "004", name: "Afghanistan" },
    { code: "051", name: "Armenia" },
    { code: "031", name: "Azerbaijan" },
    { code: "048", name: "Bahrain" },
    { code: "050", name: "Bangladesh" },
    { code: "064", name: "Bhutan" },
    { code: "096", name: "Brunei" },
    { code: "116", name: "Cambodia" },
    { code: "156", name: "China" },
    { code: "268", name: "Georgia" },
    { code: "356", name: "India" },
    { code: "360", name: "Indonesia" },
    { code: "364", name: "Iran" },
    { code: "368", name: "Iraq" },
    { code: "376", name: "Israel" },
    { code: "392", name: "Japan" },
    { code: "400", name: "Jordan" },
    { code: "398", name: "Kazakhstan" },
    { code: "408", name: "North Korea" },
    { code: "410", name: "South Korea" },
    { code: "414", name: "Kuwait" },
    { code: "417", name: "Kyrgyzstan" },
    { code: "418", name: "Laos" },
    { code: "422", name: "Lebanon" },
    { code: "458", name: "Malaysia" },
    { code: "462", name: "Maldives" },
    { code: "496", name: "Mongolia" },
    { code: "104", name: "Myanmar" },
    { code: "524", name: "Nepal" },
    { code: "512", name: "Oman" },
    { code: "586", name: "Pakistan" },
    { code: "275", name: "Palestine" },
    { code: "608", name: "Philippines" },
    { code: "634", name: "Qatar" },
    { code: "643", name: "Russia" },
    { code: "682", name: "Saudi Arabia" },
    { code: "702", name: "Singapore" },
    { code: "144", name: "Sri Lanka" },
    { code: "760", name: "Syria" },
    { code: "158", name: "Taiwan" },
    { code: "762", name: "Tajikistan" },
    { code: "764", name: "Thailand" },
    { code: "626", name: "Timor-Leste" },
    { code: "792", name: "Turkey" },
    { code: "795", name: "Turkmenistan" },
    { code: "784", name: "United Arab Emirates" },
    { code: "860", name: "Uzbekistan" },
    { code: "704", name: "Vietnam" },
    { code: "887", name: "Yemen" }
].sort((a, b) => a.name.localeCompare(b.name));

const ASIAN_CODES = ASIAN_COUNTRIES.map(c => c.code);
const ITEMS = ASIAN_COUNTRIES.map(c => ({ id: c.code, name: c.name }));

const AsiaMapSection = () => {
    const renderMap = ({ visited, hexColor, toggle }) => (
        <ComposableMap
            projection="geoMercator"
            projectionConfig={{
                scale: 280,
                center: [90, 49]
            }}
            width={900}
            height={700}
            style={{ width: '100%', height: 'auto' }}
        >
            <Geographies geography={GEO_URL}>
                {({ geographies }) =>
                    geographies
                        .filter(geo => ASIAN_CODES.includes(geo.id))
                        .map((geo) => {
                            const countryCode = geo.id;
                            const isVisited = visited.includes(countryCode);
                            return (
                                <Geography
                                    key={geo.rsmKey}
                                    geography={geo}
                                    onClick={() => toggle(countryCode)}
                                    style={geographyStyles(isVisited, hexColor)}
                                />
                            );
                        })
                }
            </Geographies>
        </ComposableMap>
    );

    return (
        <TravelMapShell
            mapType="asia"
            analyticsLocationType="asian_country"
            trackingLabel="Asia Map"
            storageKey="asia_map"
            title="🌏 Asia Travel Map"
            subtitle="Click on countries you've visited, or use the checklist below!"
            items={ITEMS}
            noun="Countries"
            unitLabel="countries"
            captionUnit="Asian countries"
            share={{
                region: 'Asia',
                fileName: 'visited-asia-map.png',
                trackId: 'asia'
            }}
            renderMap={renderMap}
        />
    );
};

export default AsiaMapSection;
